import { useEffect } from 'preact/hooks';

/**
 * Global keydown listener. Used by overlays (Drawer, ConfirmModal,
 * mobile nav drawer) for Esc-to-close.
 *
 * `deps` reuses the handler across renders without rebinding unless
 * an explicit dependency changes.
 */
export function useKeyboardShortcut(
    key: string,
    handler: (e: KeyboardEvent) => void,
    deps: unknown[] = [],
): void {
    useEffect(() => {
        const onKey = (e: KeyboardEvent) => {
            if (e.key === key) handler(e);
        };
        document.addEventListener('keydown', onKey);
        return () => document.removeEventListener('keydown', onKey);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}
